import label from "fragments/vendors/label"
import gql from "graphql-tag"

const SEARCH_LABELS = gql`
  ${label}

  query searchLabels($searchLabelsInput: SearchLabelsInput!) {
    searchLabels(searchLabelsInput: $searchLabelsInput) {
      ...Label
    }
  }
`

export default SEARCH_LABELS
